module.exports = __webpack_public_path__ + "img/assets.cb7179f8.svg";